import { useEffect, useState, ChangeEvent } from 'react';
import InputField from './InputField';
import Card from './Cards';
import { useTranslation } from 'react-i18next';

interface TemperatureValues {
  celcius: string | number;
  farenheit: string | number;
  kelvin: string | number;
}

type TemperatureUnit = keyof TemperatureValues;

interface Coeffs {
  celcius: [number, number];
  farenheit: [number, number];
  kelvin: [number, number];
}

export default function Temperature() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('temperature.pageTitle');
  }, [t]);

  const [values, setValues] = useState<TemperatureValues>({ celcius: 20, farenheit: 68, kelvin: 293.15 });
  const coeffs: Coeffs = { celcius: [1.0, 0], farenheit: [1.8, 32], kelvin: [1, 273.15] };

  function handleOnChange(event: ChangeEvent<HTMLInputElement>) {
    const name = event.target.name as TemperatureUnit;
    const value = event.target.value;
    const C = (Number(value) - coeffs[name][1]) / coeffs[name][0];
    setValues({
      celcius: name === 'celcius' ? value : C.toFixed(2),
      farenheit: name === 'farenheit' ? value : (C * 1.8 + 32).toFixed(2),
      kelvin: name === 'kelvin' ? value : (C + 273.15).toFixed(2),
    });
  }

  return (
    <div className="max-w-sm">
      <Card title={t('temperature.cardTitle')}>
        <InputField name="celcius" label={t('temperature.celsius')} step="0.1" value={values.celcius} unit="°C" onChange={handleOnChange} />
        <InputField name="farenheit" label={t('temperature.fahrenheit')} step="0.1" value={values.farenheit} unit="°F" onChange={handleOnChange} />
        <InputField name="kelvin" label={t('temperature.kelvin')} step="0.1" value={values.kelvin} unit="K" onChange={handleOnChange} />
      </Card>
    </div>
  );
}
